import { Typography } from 'antd'

const { Text } = Typography

/**
 * Placeholders the API substitutes when it builds an event chat request
 * message. Listed wherever one of those messages is edited — the program
 * default and the per-event override — so the two lists cannot drift apart.
 */
const CHAT_REQUEST_VARIABLES = [
  '{title}',
  '{date}',
  '{time}',
  '{venue}',
  '{address}',
  '{firstName}',
  '{lastName}',
  '{cardNumber}',
]

// `Text` renders a span, so it is forced to a block here: a caption placed
// after this one has to start on its own line instead of flowing beside it.
const ChatRequestVariablesHint = () => {
  return (
    <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
      Available: {CHAT_REQUEST_VARIABLES.join(' ')}
    </Text>
  )
}

export default ChatRequestVariablesHint
